<template>
  <div class="datetimeGroup">
    <div class="datetime" :style="flexStyle(itemSetting.layout.flex)">
      <div class="vdatetime setbox"
        v-if="itemSetting.action.asap.active"
        :style="setFlex(itemData.column[0].flex)">
        <div class="btn btnFull"
          :style="setDetailStyle(itemData.column[0].detail)"
          @focusout="updateCITE(itemData.column[0])">
          <CITEditor
            :model="itemData.column[0].value"
            :toolbarOption="textOption"
            :lang="activeLang" />
        </div>
        <div class="handleColumn"
          v-if="typeof (itemData.column[0].detail) !== 'undefined'">
          <button type="button" class="handle setDetail"
            @click="setDetail($event, itemData.column[0].detail)"></button>
        </div>
      </div>
      <div class="vdatetime setbox"
        v-if="itemSetting.action.settime.active"
        :style="setFlex(itemData.column[1].flex)">
        <div class="btn btnFull"
          :style="setDetailStyle(itemData.column[1].detail)"
          @focusout="updateCITE(itemData.column[1])">
          <CITEditor
            :model="itemData.column[1].value"
            :toolbarOption="textOption"
            :lang="activeLang" />
        </div>
        <div class="handleColumn"
          v-if="typeof (itemData.column[1].detail) !== 'undefined'">
          <button type="button" class="handle setDetail"
            @click="setDetail($event, itemData.column[1].detail)"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CITEditor from '@/components/CITEditor/Index.vue'
import UTIL from '@/common/util'

export default {
  name: 'DatetimeModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'itemData',
    'itemSetting'
  ],
  components: {
    CITEditor
  },
  computed: {
    dateFormat () {
      return this.$store.getters['setting/getDateFormat']
    }
  },
  data () {
    return {
      textOption: [
        'Bold', 'Italic', 'Underline', 'Strikethrough',
        'FontSize', 'FontFamily',
        'Color', 'BackgroundColor',
        'TextAlign'
      ]
    }
  },
  methods: {
    flexStyle (style) {
      if (style) {
        return {
          alignItems: style.alignItems
        }
      }
    },
    setFlex (flex) {
      return {
        flex: flex
      }
    },
    setDetailStyle (detailData) {
      const notStyles = ['options']
      const styles = Object.keys(detailData).filter(function (o) {
        return notStyles.indexOf(o) === -1
      })
      const styleObj = {}
      styles.forEach(function (x) {
        const obj = detailData[x]
        if (obj && obj.active) {
          let key = ''
          let value = ''
          switch (x) {
            case 'background':
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                styleObj[key] = value
              })
              break
            case 'border':
              styleObj['border-width'] = '1px'
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                styleObj[key] = value
              })
              break
            case 'radius':
              styleObj['border-radius'] = `${obj.tl}px ${obj.tr}px ${obj.br}px ${obj.bl}px`
              break
            case 'text':
              styleObj.color = obj.color
              break
          }
        }
      })
      return styleObj
    },
    updateCITE (target) {
      const html = target.value[this.activeLang]
      if (this.isNew) {
        Object.keys(target.value).forEach(function (lang) {
          target.value[lang] = html
        })
      }
      const fillValue = UTIL.fillLangs(target.value, target.value[this.activeLang])
      target.value = fillValue
    },
    setDetail (e, detail) {
      e.stopPropagation()
      const setbox = document.querySelectorAll('.setbox')
      const target = e.target.closest('.setbox')
      setbox.forEach(el => el.classList.remove('active'))
      target.classList.add('active')
      this.$emit('setDetail', detail)
    }
  }
}
</script>
